
export function TextTransformHelper(text: string) {
    if (text) {
        let split = text.split(/(?=[A-Z])/);
        let textFormatted = `${split[0]} ${split[1] ? split[1]?.toLowerCase() : ''} ${split[2] ? split[2]?.toLowerCase() : ''}`
        return textFormatted;
    } else {
        return ''
    }
}